import { makeStyles, shorthands } from "@fluentui/react-components";
import designTokens from "theme/customTheme";

export const useMoveDialogStyles = makeStyles({
  dialogSurface: {
    borderRadius: designTokens.borderRadius.lg,
    ...shorthands.padding(
      designTokens.spacing[6],
      designTokens.spacing[6],
      designTokens.spacing[6],
      designTokens.spacing[6],
    ),
    minWidth: "500px",
    maxWidth: "600px",
    "@media (max-width: 640px)": {
      minWidth: "unset",
      width: "calc(100vw - 32px)",
      maxWidth: "100%",
      ...shorthands.padding(
        designTokens.spacing[4],
        designTokens.spacing[3],
        designTokens.spacing[4],
        designTokens.spacing[3],
      ),
    },
  },

  workspacePickerWrapper: {
    ...shorthands.padding(designTokens.spacing[2], 0),
  },
});
